// utils
import { generateRandomCode } from 'app/utils';

function formatProcedureCallback(procedureIndication) {
  const {
    id,
    procedureId,
    justification,
    instructions,
    frequencyTypeId,
    frequencyAmount,
    calendarType,
    suggestScheduling,
    scheduleType,
    time,
    times,
    date,
    dates,
    shift,
    shifts,
    daysOfWeek,
    matMedIndications,
    formAddOn
  } = procedureIndication;

  return {
    procedureId,
    justification,
    instructions,
    frequencyTypeId,
    frequencyAmount,
    calendarType,
    suggestScheduling,
    scheduleType,
    time,
    times,
    date,
    dates,
    shift,
    shifts,
    daysOfWeek,
    matMedIndications,
    formAddOn: {
      ...formAddOn,
      initialEvaluationNoteId: id,
      randomCode: generateRandomCode()
    }
  };
}

export { formatProcedureCallback };
